import React from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { hasBank, isEditActionState } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import CheckBoxLabelHookForm from "../../../../../components/CheckBoxLabelHookForm";

interface IOfficeBankDetails {
  isAdd?: boolean;
}
export const OfficeBankDetails: React.FC<IOfficeBankDetails> = ({ isAdd }) => {
  const formMethods = useFormContext();
  const {
    register,
    formState: { errors },
    watch,
  } = formMethods;
  const [, setHasBankName] = useRecoilState(hasBank);
  const [actionEditState] = useRecoilState(isEditActionState);

  const handleInputChange = (event) => {
    if (isAdd) {
      const value = event.target.value?.trim();
      if (value !== "") {
        setHasBankName(true);
      } else {
        setHasBankName(false);
      }
    }
  };

  return (
    <>
      <div className="bg-bgDB mr-3 pb-1">
        <div className="bg-white shadow-lg h-full">
          <div className="">
            <div className="grid grid-cols-6 mx-3 pb-2 gap-6 py-2">
              <div className="col-span-2 my-1">
                <TextInputLabelHookForm
                  name="bankName"
                  label="Bank Name"
                  type="text"
                  required={true}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  className={
                    errors.bankName &&
                    errors.bankName.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={register("bankName", {
                    required: {
                      value: true,
                      message: "Required Field",
                    },
                  })}
                  maxLength={150}
                />
              </div>
              {actionEditState && (
                <div className="my-3 mx-3">
                  <CheckBoxLabelHookForm
                    name="isActive"
                    type="checkbox"
                    label={
                      watch("isActive")
                        ? "Uncheck to Deactivate"
                        : "Check to Activate"
                    }
                    validation={{
                      required: {
                        value: false,
                        message: "Required Field",
                      },
                    }}
                    register={register}
                    className={
                      errors.isActive &&
                      errors.isActive.message &&
                      "border-2 border-red-500 col-span-2 "
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfficeBankDetails;
